<template>
  <div>
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="退款用户">
            <el-select
              v-model="queryForm.userId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="来源">
            <el-select
              v-model="queryForm.genesis"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="退款原因">
            <el-select
              v-model="queryForm.reason"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in reasons"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select
              v-model="queryForm.deviceType"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in deviceTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button
            icon="el-icon-download"
            native-type="submit"
            size="medium"
            type="primary"
            @click="handleDownload"
        >
          下载
        </el-button>
          </el-form-item>
          
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="transaction_id"
        border
        stripe
      >
        <el-table-column align="center" label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="后台" prop="genesis" width="80">
        </el-table-column>
        <el-table-column align="center" label="交易号" prop="transactionId">
        </el-table-column>
        <el-table-column align="center" label="交易单号" prop="pspOrderId">
        </el-table-column>

        <el-table-column align="center" label="退款类型">
          <template #default="{ row }">
            {{ row.refundType | refundStatusFilter }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="退款金额"
          prop="amount"
          width="100"
        >
          <template slot-scope="scope">
            {{
              scope.row.genesis === "777"
                ? scope.row.amount == 0
                  ? 0
                  : (scope.row.amount / 100).toFixed(2)
                : scope.row.amount
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="退款原因" prop="amount">
          <template slot-scope="scope">
            {{ scope.row.reasonList | reasonFilter }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="退款时间" prop="addTimeStr">
        </el-table-column>
        <el-table-column
          align="center"
          label="退款用户账号"
          prop="employeeName"
        >
        </el-table-column>
        <el-table-column align="center" label="退款货道" prop="channel">
          <template slot-scope="scope">
            {{ scope.row.channel ? Number(scope.row.channel) + 1 : ' ' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="设备名称" prop="deviceName">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            label="注释"-->
        <!--            prop="note"-->
        <!--        >-->
        <!--        </el-table-column>-->
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getRefundLog, getUserList,getrefundLogDownload } from "@/api/order";
export default {
  name: "refund-log",
  data() {
    return {
      dateValue: [], //
      queryForm: {
        page: 1,
        pageSize: 10,
      }, // 搜索条件表单
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数,
      tableData: [], // 表格数据
      userList: [], // 用户数据
      options: [
        { value: "2.0", label: "2.0" },
        { value: "3.0", label: "3.0" },
        { value: "5.0", label: "5.0" },
        { value: "5.0大牌", label: "5.0大牌" },
        { value: "777", label: "777" },
      ],
      reasons: [
        { label: "商品损坏", value: "1" },
        { label: "未出货", value: "2" },
        { label: "重复支付", value: "3" },
        { label: "景区账号退款失败", value: "4" },
        { label: "出货与下单商品不符", value: "5" },
        { label: "外壳损坏", value: "6" },
        { label: "纪念章/大牌/集章册瑕疵", value: "7" },
        { label: "未出货", value: "8" },
        { label: "重复支付", value: "9" },
        { label: "出错货", value: "10" },
        { label: "7天无理由", value: "11" },
        { label: "测试", value: "12" },
        { label: "大牌机器卡死", value: "13" },
        { label: "大牌打印瑕疵", value: "14" },
        { label: "777不出货", value: "15" },
        { label: "777漏墨", value: "16" },
         //780设备退款原因
        { label: "激光雕刻失败", value: "18" },
        { label: "激光雕刻错位", value: "19" },
        { label: "商品损坏", value: "20" },
      ], // 退款原因
      deviceTypeList: [
        { value: '0', label: '全部' },
        { value: '1', label: '771/772' },
        { value: '2', label: '776' },
        { value: '3', label: '775' },
        { value: '4', label: '779' },
        { value: '5', label: '780' },
        { value: '6', label: '781' },
        { value: '7', label: '782' },
        { value: '8', label: '783' },
      ], // 设备类型
    };
  },
  created() {
    this.fetchData();
    this.getUser();
  },
  methods: {
    getdata(){
      let params = {
        page: this.queryForm.page,
        pageSize: this.queryForm.pageSize,
        start:
          this.dateValue && this.dateValue.length > 0
            ? this.dateValue[0]
            : undefined, // 开始时间
        end:
          this.dateValue && this.dateValue.length > 0
            ? this.dateValue[1]
            : undefined, // 结束时间
        userId: this.queryForm.userId,
        reason: this.queryForm.reason || undefined,
        genesis: this.queryForm.genesis || [],
        deviceType: this.queryForm.deviceType || undefined,
      };
      return params;
    },
    handleDownload(){
      let params = this.getdata()
     this.$confirm(`确认下载数据吗？`).then(() => {
        // 下载
        getrefundLogDownload(params).then((data) => {
          console.log(data,'data');
          this.download(data);
        })
            .catch((error) => {
              // this.$message.error(error);
            });
      })
    },
    download(resp) {
      const fileName = '退款日志';
      const blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = href;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },

    getUser() {
      getUserList().then((res) => {
        if (res && res.code === "2000") {
          this.userList = res.body; // 这是请求到的列表
        }
      });
    },
    fetchData() {
      // 请求数据
      // let params = {
      //   page: this.queryForm.page,
      //   pageSize: this.queryForm.pageSize,
      //   start:
      //     this.dateValue && this.dateValue.length > 0
      //       ? this.dateValue[0]
      //       : undefined, // 开始时间
      //   end:
      //     this.dateValue && this.dateValue.length > 0
      //       ? this.dateValue[1]
      //       : undefined, // 结束时间
      //   userId: this.queryForm.userId,
      //   reason: this.queryForm.reason || undefined,
      //   genesis: this.queryForm.genesis || [],
      // };
      let params = this.getdata()
      getRefundLog(params)
        .then((res) => {
          if (res && res.code === "2000" && res.body) {
            this.tableData = res.body.data || []; // 这是请求到的列表
            this.page = res.body.page;
            this.pageSize = res.body.pageSize;
            this.total = res.body.totalRecords;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      // 查询
      this.queryForm.page = 1;
      this.fetchData();
    },
  },
  filters: {
    refundStatusFilter(status) {
      const outMap = {
        AUTOREFUND: "自动退款",
        MANUALREFUND: "手工退款",
        REFUNDALL: "全部退款",
        REFUNDPART: "部分退款",
        "": "未退款", // 待后续使用
      };
      return outMap[status];
    },
    reasonFilter(val) {
      if (val[0] === "") {
        return "-";
      } else {
        const reasons = {
          1: "商品损坏",
          2: "未出货",
          3: "重复支付",
          4: "景区账号退款失败",
          5: "出货与下单商品不符",
          6: "外壳损坏",
          7: "纪念章/大牌/集章册瑕疵",
          8: "未出货",
          9: "重复支付",
          10: "出错货",
          11: "7天无理由",
          12: "测试",
          13: "大牌机器卡死",
          14: "大牌打印瑕疵",
          15: "777不出货",
          16: "777漏墨",
          18: "激光雕刻失败",
          19: "激光雕刻错位",
          20: "商品损坏"
        };
        let reasonArr = [];
        for (let key of val) {
          reasonArr.push(reasons[key]);
        }
        return reasonArr.join("、");
      }
    },
  },
};
</script>

<style scoped>
.tableCard {
  margin-top: 20px;
}
</style>